import React, { useState } from "react";

export default function TablaReact({
  columns = [],
  data = [],
  showIndex = false,
  showCheckbox = false,
  onSelect = () => {},
  loading = false,
  /** Última(s) fila(s) de totales u otro pie: mismo `<tbody>` que los datos para alinear columnas. */
  footer = null,
  /** Centra encabezados y celdas de datos (útil en tablas numéricas). */
  centerContent = false,
}) {
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleRow = (row) => {
    const exists = selectedRows.includes(row);
    const updated = exists
      ? selectedRows.filter((r) => r !== row)
      : [...selectedRows, row];
    setSelectedRows(updated);
    onSelect(updated);
  };

  const renderCell = (item, column) => {
    if (typeof column.render === "function") {
      return column.render(item[column.accessor], item);
    }
    return item[column.accessor];
  };

  return (
    <div
      className={`tabla-container${
        centerContent ? " tabla-container--centered" : ""
      }`}
    >
      <table className="tabla">
        <thead>
          <tr>
            {showCheckbox && <th></th>}
            {showIndex && <th>#</th>}
            {columns.map((col) => (
              <th key={col.accessor} className={col.className || ''}>
                {col.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td
                colSpan={
                  columns.length + (showCheckbox ? 1 : 0) + (showIndex ? 1 : 0)
                }
                className="loading-cell"
              >
                Cargando datos...
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={
                  columns.length + (showCheckbox ? 1 : 0) + (showIndex ? 1 : 0)
                }
                className="empty-cell"
              >
                No hay datos para mostrar.
              </td>
            </tr>
          ) : (
            <>
              {data.map((item, idx) => (
                <tr key={idx}>
                  {showCheckbox && (
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(item)}
                        onChange={() => toggleRow(item)}
                      />
                    </td>
                  )}
                  {showIndex && <td>{idx + 1}</td>}
                  {columns.map((col) => (
                    <td key={col.accessor} className={col.className || ''}>
                      {renderCell(item, col)}
                    </td>
                  ))}
                </tr>
              ))}
              {footer && !loading && data.length > 0 ? footer : null}
            </>
          )}
        </tbody>
      </table>
      <style>{`
        .tabla-container {
          overflow-x: auto;
          font-family: Arial, sans-serif;
          background-color: transparent;
          max-width: 100%;
        }
        .tabla {
          width: 100%;
          border-collapse: collapse;
          background-color: transparent;
        }
        .tabla thead {
          background-color: transparent;
        }
        .tabla th {
          padding: 12px 10px;
          text-align: left;
          font-weight: normal;
          font-size: 14px;
          color: #6b7280;
          border-bottom: 1px solid #e5e7eb;
          border-right: 1px solid #e5e7eb;
          position: sticky;
          top: 0;
          background-color: #f4f4f4;
          z-index: 10;
        }
        .tabla thead th {
          min-width: 10px;
        }
        .tabla thead th:last-child {
          border-right: none;
        }
        .tabla td {
          padding: 12px 10px;
          font-size: 13px;
          color: #111827;
          background-color: transparent;
          border-bottom: 1px solid #e5e7eb;
          border-right: 1px solid #e5e7eb;
          white-space: normal;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        .tabla tr td:last-child {
          border-right: none;
        }
        .tabla tbody tr:not(.tabla-totals-row):hover {
          background-color: #f9fafb;
        }
        .tabla input[type="checkbox"] {
          cursor: pointer;
        }
        .loading-cell,
        .empty-cell {
          text-align: center;
          padding: 20px;
          color: #6b7280;
          font-style: italic;
        }

        .tabla tbody tr.tabla-totals-row td {
          font-weight: 600;
          background-color: #eef1f4;
          border-top: 2px solid #d1d5db;
        }
        .tabla tbody tr.tabla-totals-row:hover td {
          background-color: #eef1f4;
        }

        .tabla-container--centered .tabla th,
        .tabla-container--centered .tabla td {
          text-align: center;
        }
        
        /* Estilos responsivos para la columna Observaciones */
        .col-observaciones {
          width: 18%;
          min-width: 120px;
          max-width: 200px;
        }
        
        @media (max-width: 768px) {
          .tabla-container {
            font-size: 12px;
          }
          .tabla th {
            font-size: 12px;
            padding: 8px 6px;
          }
          .tabla td {
            font-size: 11px;
            padding: 8px 6px;
          }
          .col-observaciones {
            width: 22%;
            min-width: 100px;
            max-width: 150px;
          }
        }
        
        @media (max-width: 480px) {
          .tabla th {
            font-size: 11px;
            padding: 6px 4px;
          }
          .tabla td {
            font-size: 10px;
            padding: 6px 4px;
          }
          .col-observaciones {
            width: 25%;
            min-width: 80px;
            max-width: 120px;
          }
        }
      `}</style>
    </div>
  );
}
